var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFile({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 33,
    viewBox: "0 0 36 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.0626 29.5625V28.875C19.0626 24.986 19.0626 23.0414 20.3511 21.8332C21.6396 20.625 23.7133 20.625 27.8608 20.625H28.594M29.3271 18.3468V13.75C29.3271 8.56455 29.3271 5.97183 27.6091 4.36091C25.8913 2.75 23.1262 2.75 17.5962 2.75C12.0662 2.75 9.30116 2.75 7.58319 4.36091C5.86523 5.97182 5.86523 8.56455 5.86523 13.75V19.9983C5.86523 24.4601 5.86523 26.6911 7.16454 28.2022C7.42703 28.5075 7.72358 28.7855 8.04914 29.0316C9.66065 30.25 12.0399 30.25 16.7982 30.25C17.8329 30.25 18.3501 30.25 18.8238 30.0932C18.9224 30.0607 19.0189 30.0231 19.1131 29.9809C19.5664 29.7776 19.9321 29.4346 20.6637 28.7486L27.6091 22.236C28.4569 21.4411 28.8806 21.0437 29.104 20.5382C29.3271 20.0329 29.3271 19.4708 29.3271 18.3468Z",
    stroke: "#141B34",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFile);
export default __webpack_public_path__ + "static/media/file.288e76fca9f48690e3a24529576b38c2.svg";
export { ForwardRef as ReactComponent };